import useMobileLayout from 'Hooks/useMobileLayout';
import {
  FDBox,
  FDSecondaryActionButton,
  FDStack, FDTitleText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { DataValueMap } from 'Helpers/Testing';
import Relationship from 'facet-rest/src/domain/Relationship';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { BorderedTransparentBox } from 'Packages/FacetDesign/Components/Experimental/BorderedTransparentBox';

const GoalStrategyOverviewBasicInfoCard = ({
  title, detailsRelationship, setDetailsResource,
}) => {
  const isMobile = useMobileLayout();
  const [loading, setLoading] = useState(false);
  const { displayErrorMessage } = useSnackbarContext();

  const handleOnClick = async () => {
    try {
      setLoading(true);
      const [detailsResource] = await detailsRelationship.link('related').get();
      setDetailsResource(detailsResource);
    } catch (err) {
      if (err.errors) {
        displayErrorMessage(err, err.errors);
      } else {
        displayErrorMessage(err, 'Error: Button click failed, please try again');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <BorderedTransparentBox
      color={'info'}
      appearance={'outlined'}
      padding={3}
      width={isMobile ? '100%' : '365px'}
      {...DataValueMap.init('goal-strategy-overview-basic-info-card').build()}
    >
      <FDStack direction={'column'} spacing={2} justifyContent={'space-between'} height={'100%'}>
        <FDTitleText size={'lg'} value={title} />
        {detailsRelationship
          ? (
            <FDBox>
              <FDSecondaryActionButton
                loading={loading}
                label={detailsRelationship.meta('prompt')}
                size={'sm'}
                onClick={handleOnClick}
              />
            </FDBox>
          ) : null
        }
      </FDStack>
    </BorderedTransparentBox>
  );
};

GoalStrategyOverviewBasicInfoCard.defaultProps = {
  detailsRelationship: undefined,
};

GoalStrategyOverviewBasicInfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  detailsRelationship: PropTypes.instanceOf(Relationship),
  setDetailsResource: PropTypes.func.isRequired,
};

export default GoalStrategyOverviewBasicInfoCard;
